import { render, staticRenderFns } from "./BundleDataLayout2.vue?vue&type=template&id=15a1b683&"
import script from "./BundleDataLayout2.vue?vue&type=script&lang=js&"
export * from "./BundleDataLayout2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports